import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "./Header.css";

function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 4);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`Header ${scrolled ? "Header--scrolled" : ""}`}>
      <div className="Header__stack">
        {/* Brand (centered) */}
        <div className="Header__brandBlock">
          <NavLink to="/" className="Header__brandLink Header__brandLink--logo">
            <img
              className="Header__logo"
              src={"/assets/brand/brand-title.png"}
              alt="Take 3"
            />
          </NavLink>
        </div>

        {/* Always-visible nav (centered) */}
        <div className="Header__row Header__row--navline">
          <nav className="Header__nav Header__nav--always" aria-label="Primary">
            <NavItem to="/movies">Commercials</NavItem>
            <NavItem to="/narratives">Narratives</NavItem>
            <NavItem to="/music-videos">Music Videos</NavItem>
            <NavItem to="/stills">Stills</NavItem>
            <NavItem to="/info">Info</NavItem>
          </nav>
        </div>
      </div>
    </header>
  );
}

function NavItem({ to, children }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `Header__link ${isActive ? "is-active" : ""}`
      }
    >
      <span className="Header__linkText">{children}</span>
      <span className="Header__underline" />
    </NavLink>
  );
}

export default Header;
